import { render, staticRenderFns } from "./PerfilControl.vue?vue&type=template&id=a333c1e6&scoped=true"
import script from "./PerfilControl.vue?vue&type=script&lang=ts"
export * from "./PerfilControl.vue?vue&type=script&lang=ts"
import style0 from "./PerfilControl.vue?vue&type=style&index=0&id=a333c1e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a333c1e6",
  null
  
)

export default component.exports